module.exports = __webpack_public_path__ + "img/right-bottom-radius.158d3d63.svg";